import { ApiProperty } from '@nestjs/swagger'
import { ArrayMinSize, IsArray, IsUUID } from 'class-validator'

/**
 * DTO pour la requête batch de classes (récupération légère id + nom)
 */
export class BatchClassesRequestDto {
  @ApiProperty({
    description: 'IDs des classes à récupérer',
    example: ['550e8400-e29b-41d4-a716-446655440000'],
    type: [String],
  })
  @IsArray()
  @ArrayMinSize(1)
  @IsUUID('4', { each: true })
  classIds!: string[]
}
